import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import './reset.css';
import { ImagePreview } from 'vant';


createApp(App).use(router).use(Vant).use(ImagePreview).mount('#app')
